import { render, staticRenderFns } from "./panelPoint.vue?vue&type=template&id=1d3a2226&scoped=true&"
import script from "./panelPoint.vue?vue&type=script&lang=js&"
export * from "./panelPoint.vue?vue&type=script&lang=js&"
import style0 from "./panelPoint.vue?vue&type=style&index=0&id=1d3a2226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3a2226",
  null
  
)

export default component.exports